import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ApiKeysPermissionsCard } from '../components/profile/ApiKeysPermissionsCard';
import { Card, CardContent } from '../components/ui';
import { useAuth, usePage } from '../contexts';
import { isOrganizationAdmin } from '../utils/organizationRole';

const OrganizationApiKeys: React.FC = () => {
  const { t } = useTranslation();
  const { setPageInfo } = usePage();
  const { user } = useAuth();

  useEffect(() => {
    setPageInfo(
      t('organization.apiKeysAndPermissionsTitle'),
      t('organization.apiKeysAndPermissionsDescription')
    );
  }, [setPageInfo, t]);

  const canManageApiKeys = isOrganizationAdmin(user);

  if (!canManageApiKeys) {
    return (
      <Card>
        <CardContent className="p-8 text-center text-gray-600 dark:text-gray-300">
          {t('organization.ownerOnly')}
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      <ApiKeysPermissionsCard />
    </div>
  );
};

export default OrganizationApiKeys;
